import { render } from "./ViewGridIcon.vue?vue&type=template&id=657d4f59"
import script from "./ViewGridIcon.vue?vue&type=script&lang=js"
export * from "./ViewGridIcon.vue?vue&type=script&lang=js"
script.render = render

export default script